/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Force_Render_AudioInputs */

const en_force_render_audio = /** @type {(inputs: Force_Render_AudioInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Force Render Audio...`)
};

const fr_force_render_audio = /** @type {(inputs: Force_Render_AudioInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Forcer le rendu audio...`)
};

const de_force_render_audio = /** @type {(inputs: Force_Render_AudioInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Audio erzwingen...`)
};

const it_force_render_audio = /** @type {(inputs: Force_Render_AudioInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Forza rendering audio...`)
};

const ru_force_render_audio = /** @type {(inputs: Force_Render_AudioInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Принудительное воспроизведение звука...`)
};

const es_force_render_audio = /** @type {(inputs: Force_Render_AudioInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Forzar renderizado de audio...`)
};

const zh_cn2_force_render_audio = /** @type {(inputs: Force_Render_AudioInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`强制渲染音频...`)
};

const ja_force_render_audio = /** @type {(inputs: Force_Render_AudioInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`オーディオの強制レンダリング...`)
};

const hi_force_render_audio = /** @type {(inputs: Force_Render_AudioInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ऑडियो को जबरदस्ती रेंडर करें...`)
};

const pt_pt2_force_render_audio = /** @type {(inputs: Force_Render_AudioInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Forçar renderização de áudio...`)
};

/**
* | output |
* | --- |
* | "Force Render Audio..." |
*
* @param {Force_Render_AudioInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const force_render_audio = /** @type {((inputs?: Force_Render_AudioInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Force_Render_AudioInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_force_render_audio(inputs)
	if (locale === "de") return de_force_render_audio(inputs)
	if (locale === "it") return it_force_render_audio(inputs)
	if (locale === "ru") return ru_force_render_audio(inputs)
	if (locale === "es") return es_force_render_audio(inputs)
	if (locale === "zh-CN") return zh_cn2_force_render_audio(inputs)
	if (locale === "ja") return ja_force_render_audio(inputs)
	if (locale === "hi") return hi_force_render_audio(inputs)
	if (locale === "pt-PT") return pt_pt2_force_render_audio(inputs)
	return en_force_render_audio(inputs)
});